import { configureStore } from '@reduxjs/toolkit';

import authSlice from './auth/auth-slice';
import userSlice from './users/user-slice';
import skillSlice from './skills/skill-slice';
import skillLevelSlice from './skills/skilllevel-slice';
import notificationSlice from './notification/notification-slice';
import queueSlice from './queues/queue-slice';
import loadingSlice from './spinner/spinner-slice';
import queueMemberSlice from './queues/queue-member-slice';

const store = configureStore({
  reducer: { 
      auth: authSlice.reducer, 
      users: userSlice.reducer, 
      skills: skillSlice.reducer,
      queues: queueSlice.reducer,
      skillLevels: skillLevelSlice.reducer,
      queueMembers: queueMemberSlice.reducer,
      notification: notificationSlice.reducer,
      loading: loadingSlice.reducer, },  
});

export default store;